import React, { Component } from "react";
import ListQuestion from "../../list/interface/list_question";

import ListHashtags from "../../list/interface/list_hahstags";

import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

class QuestionSelection extends Component {
  state = { alreadySelected: false };

  componentDidMount() {
    this.questionAlreadySelected();
  }
  render() {
    const style = this.state.alreadySelected
      ? { cursor: "pointer", position: "relative" }
      : { cursor: "pointer", position: "relative" };

    const styleFont = this.state.alreadySelected ? {} : {};

    const checkStyle = this.state.alreadySelected
      ? { color: "#ff5116", marginTop: "5px" }
      : { color: "#f8f9fa", marginTop: "5px" };

    return (
      <div
        className="question_answer_v2 pb-3 pt-3"
        onClick={this.handleClickOnQuestion}
        style={style}
      >
        <div className="question_v2" style={style}>
          <div
            style={{
              position: "absolute",
              width: "30px",
              height: "30px",
              borderRadius: "15px",
              backgroundColor: "white",
              right: "-10px",
              bottom: "5px"
            }}
          >
            <FontAwesomeIcon
              className="yaystack_icon_navBar"
              icon={faCheck}
              style={checkStyle}
            />
          </div>
          <label className="question_title_v2" style={styleFont}>
            {this.props.question.name}
          </label>
          <label className="question_asked_v2" style={styleFont}>
            Question asked by{" "}
            <Link
              style={{ cursor: "pointer" }}
              to={"/users/" + this.props.question.user.username}
            >
              <span>@{this.props.question.user.username}</span>
            </Link>
          </label>
          <ListHashtags category={this.props.question.category} />
        </div>
      </div>
    );
  }
  handleClickOnQuestion = event => {
    event.preventDefault();
    const alreadySelected = !this.state.alreadySelected;
    this.setState({ alreadySelected });
    if (alreadySelected) return this.props.selectQuestion(this.props.question);
    this.props.unselectQuestion(this.props.question);
  };

  questionAlreadySelected = e => {
    for (var i in this.props.questionsSelected) {
      if (this.props.questionsSelected[i].id === this.props.question.id) {
        this.setState({ alreadySelected: true });
        return;
      }
    }
    //this.setState({ alreadySelected: false });
  };
}

export default QuestionSelection;



// WEBPACK FOOTER //
// ./src/components/search/question/question_selection.jsx